import { v4 as uuidv4 } from "uuid"

import { WorkflowNode } from "lib/types/workflow"

export const createConditionNode = (): WorkflowNode => ({
  id: uuidv4(),
  type: "condition",
  position: { x: 0, y: 0 },
  data: {
    nodeType: "CONDITION",
    label: "New Condition",
    checkType: "PAYMENT_PROVIDER_NAME",
    comparison: "EQUALS",
    values: []
  }
})

export const createActionNode = (): WorkflowNode => ({
  id: uuidv4(),
  type: "action",
  position: { x: 0, y: 0 },
  data: {
    nodeType: "ACTION",
    label: "New Action",
    actionType: "CANCELLATION"
  }
})
